import {
  getLocalStorageItem,
  LocalStorageKeys,
  removeLocalStorageItem,
  setLocalStorageItem,
} from "utils/react/localStorage";

export type PendingShopifyLink = {
  token: string;
  shop: string;
  expiresAt: number;
};

// Matches the server-side pending-install TTL; the stash is only a bridge
// across the Auth0 login redirect, which loses query params.
const PENDING_LINK_TTL_MS = 30 * 60 * 1000;

export const savePendingShopifyLink = (token: string, shop: string) => {
  const pending: PendingShopifyLink = {
    token,
    shop,
    expiresAt: Date.now() + PENDING_LINK_TTL_MS,
  };
  setLocalStorageItem(
    LocalStorageKeys.CONNEXX_PENDING_SHOPIFY_LINK,
    JSON.stringify(pending)
  );
};

export const getPendingShopifyLink = (): PendingShopifyLink | null => {
  try {
    const raw = getLocalStorageItem(
      LocalStorageKeys.CONNEXX_PENDING_SHOPIFY_LINK
    );
    if (!raw) return null;
    const pending = JSON.parse(raw) as PendingShopifyLink;
    if (!pending?.token || !pending?.shop) return null;
    if (!pending.expiresAt || pending.expiresAt < Date.now()) {
      clearPendingShopifyLink();
      return null;
    }
    return pending;
  } catch {
    return null;
  }
};

export const clearPendingShopifyLink = () => {
  removeLocalStorageItem(LocalStorageKeys.CONNEXX_PENDING_SHOPIFY_LINK);
};
